import { SVGProps } from 'react';

/**
 * SVG Icon Components
 * Each icon is a 512x512 viewBox SVG
 */

export const bakeryIcons: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  bread: (props) => (
    <svg viewBox="0 0 497 497" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m485.286 284.743c0 144.698-473.58 144.698-473.58 0 0-105.144 106.014-190.38 236.79-190.38s236.79 85.236 236.79 190.38z"
        fill="#cf7a15"
      />
      <g>
        <path
          d="m404.742 123.656c-4.445-2.893-10.622-1.723-13.249 2.878-28.149 49.3-72.052 141.361-111.045 134.876-25.726-4.279 17.166-125.329 32.389-164.039 2.177-5.535-1.208-11.701-7.063-12.811-16.906-3.208-34.478-5.029-52.521-5.302-3.019 1.705-5.413 3.056-8.432 4.761-33.474 57.76-93.319 174.036-127.307 161.702-15.722-5.705-.441-85.026 14.089-125.2 2.914-8.056-5.496-15.566-13.185-11.761-71.046 35.162-118.418 98.257-118.418 170.254 0 190.631 499.122 179.221 496.993 0-.745-62.741-35.98-118.73-92.251-155.358z"
          fill="#f0a346"
        />
      </g>
      <g fill="#eb8f21">
        <path d="m265.775 84.56c5.854 1.111 9.24 7.276 7.063 12.811-15.223 38.71-18.848 101.24-14.671 122.128 4 20 14.412 28.494 14.412 28.494-2.742-33.372 27.89-119.173 40.258-150.623 2.177-5.535-1.208-11.701-7.063-12.811-16.906-3.208-34.478-5.029-52.521-5.302-1.642.927-3.099 1.75-4.573 2.582 5.766.755 11.47 1.654 17.095 2.721z" />
        <path d="m111.074 229.863c-1.818-26.451 9.567-79.033 20.529-109.341 2.914-8.056-5.495-15.566-13.185-11.761-9.966 4.932-19.465 10.414-28.433 16.393-11.152 67.679 18.848 104.346 21.089 104.709z" />
        <path d="m404.742 123.656c-4.445-2.893-10.622-1.723-13.249 2.878-2.116 3.706-4.322 7.657-6.607 11.785 44.419 36.109 71.456 85.819 72.108 140.694 1.024 86.184-113.867 133.554-233.426 138.32 132.507 5.315 274.564-42.528 273.426-138.32-.746-62.74-35.981-118.729-92.252-155.357z" />
      </g>
    </svg>
  ),
  buns: (props) => (
    <svg
      id="fi_15570978"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      {...props}
    >
      <path
        d="m428.27 409.36c-79 71.42-199 91.05-297.34 14.6-27.14-21.11-35.51-36.3-74-62.5-106.55-72.46-30.64-211.17-30.64-212.1 55.01-113.71 164.47-115.12 219.61-107.58a229.14 229.14 0 0 1 33.36 6.8s4.31-.72 11.81-1.21c105.62-6.76 213.58 64.82 220.54 173 4.16 66.2-27.67 138.7-83.34 188.99z"
        fill="#d15934"
      ></path>
      <path
        d="m511.62 220.34c-5.71 94.26-77.94 194.23-183.87 221.71-103.75 26.95-177.45-26.93-212.91-62.55a358.92 358.92 0 0 0 -49.37-41.72c-32.17-22.29-79.18-75-42.56-181.11 53.77-120.95 166.7-122.59 223-114.89a229.14 229.14 0 0 1 33.36 6.8s4.31-.72 11.82-1.21c110.08-7.05 213.91 69.04 220.53 172.97z"
        fill="#e57c35"
      ></path>
      <path
        d="m481.23 245.44c-.89 28.4-51.53 64.67-73.66 76.51-17 9.1-60.61 38.49-121.88 40.15-21.55.59-129-17.87-165.65-60.75-21.82-25.5-32.83-59.46-55-70.11s-28.4-55.9-22.19-110.55c81.91-119.97 236.42-72.11 236.42-72.11s108-18.32 186.86 68c0 3.55 18.22 27.86 15.1 128.86z"
        fill="#f4a337"
      ></path>
      <path
        d="m364.47 134.07s39.55 20.05 19 62c-10.65 21.78-20.85 32.66-47.72 37.15-11.39 1.9-38.27 15.78-54.83 17s-70.18-17.79-81.65-24.46c-43.38-25.25-39.43-54.43-44.17-65.47s.39-33.13 9.07-46.93-12.58-8.36-12.58-8.36l-12.59 80.49s22.08 54.39 52.85 70.58 72.55 36.3 126.15 18.93 107.28-56 91.9-106.49-45.43-34.44-45.43-34.44z"
        fill="#e57c35"
      ></path>
      <path
        d="m311.5 181.17s2.29 4.26-11.91 14.89-35.19 6.78-43.59 2.94-28.85-10.36-33.28-21-6.58-43 10.57-54.51c0 0-11.46 38.83 5.1 48.3s73.11 9.38 73.11 9.38z"
        fill="#e57c35"
      ></path>
      <path
        d="m421.07 204.87c-17.59 52.22-95.17 85.58-149 85.58-94.61 0-167.12-90.64-137.86-162 18.64-45.49 71.36-72.27 111.74-86.64a229.14 229.14 0 0 1 33.36 6.8s4.31-.72 11.82-1.21c-28.29 6.6-117.22 31.69-140.25 87.87-26.51 64.63 51.71 150 140.47 135.57 82.65-13.42 143.45-73.12 101.39-117.39-42.72-44.91-142-36.36-148.68-13.71-3.54 11.95 3.51 20.37 8 24.33 10 8.72 22.76 15.9 40.61 12.77 4.91-.87 16.76-4.36 18.94-1.15 2.8 4.13-.54 9.09-5.1 11.13-41.19 18.48-91.6-12.42-79.79-52.21 3.77-12.72 17.65-22.57 39.1-27.73 75.05-18.05 179.43 26.12 155.25 97.99z"
        fill="#d15934"
      ></path>
      <g fill="#fec">
        <path d="m121.12 105.24c-2.35 5.76-9.72 10.56-15.65 10.76a4.59 4.59 0 0 1 -4.38-6.37c2.37-5.57 9.59-10.63 15.65-10.75a4.61 4.61 0 0 1 4.38 6.36z"></path>
        <path d="m190.77 138.46c-2.35 5.72-9.72 10.55-15.65 10.76a4.6 4.6 0 0 1 -4.38-6.38c2.37-5.56 9.59-10.62 15.65-10.74a4.61 4.61 0 0 1 4.38 6.36z"></path>
        <path d="m278.92 141c-2.37 5.75-9.75 10.56-15.65 10.76a4.6 4.6 0 0 1 -4.38-6.38c2.37-5.56 9.59-10.62 15.65-10.74a4.61 4.61 0 0 1 4.38 6.36z"></path>
        <path d="m206.63 290.05c-2.36 5.73-9.73 10.56-15.65 10.76a4.6 4.6 0 0 1 -4.39-6.37c2.37-5.57 9.59-10.62 15.65-10.75a4.62 4.62 0 0 1 4.39 6.36z"></path>
        <path d="m340 320.12c-2.36 5.73-9.72 10.56-15.65 10.76a4.59 4.59 0 0 1 -4.38-6.37c2.36-5.56 9.59-10.62 15.65-10.75a4.61 4.61 0 0 1 4.38 6.36z"></path>
        <path d="m79.33 183.82c-2.36 5.72-9.73 10.55-15.65 10.76a4.6 4.6 0 0 1 -4.39-6.38c2.37-5.57 9.6-10.62 15.65-10.74a4.62 4.62 0 0 1 4.39 6.36z"></path>
        <path d="m304.88 74.86c-2.37 5.75-9.76 10.56-15.65 10.76a4.6 4.6 0 0 1 -4.39-6.37c2.37-5.57 9.6-10.63 15.65-10.75a4.62 4.62 0 0 1 4.39 6.36z"></path>
        <path d="m394.92 101c-6.05-.12-13.28-5.17-15.65-10.74a4.61 4.61 0 0 1 4.39-6.39c6 .21 13.32 5.1 15.65 10.76a4.61 4.61 0 0 1 -4.39 6.37z"></path>
        <path d="m196.46 168.8c6.06.12 13.28 5.18 15.65 10.75a4.6 4.6 0 0 1 -4.39 6.38c-5.95-.2-13.3-5.07-15.64-10.76a4.61 4.61 0 0 1 4.38-6.37z"></path>
        <path d="m92.48 149.82c-4.92 2.51-12.38 1.05-16-2.89a4.83 4.83 0 0 1 1.38-7.62c4.74-2.39 12.28-1.22 16 2.88a4.87 4.87 0 0 1 -1.38 7.63z"></path>
        <path d="m122.39 198.07c-4.93 2.51-12.38 1.05-16-2.89a4.83 4.83 0 0 1 1.38-7.62c4.75-2.39 12.28-1.22 16 2.87a4.88 4.88 0 0 1 -1.38 7.64z"></path>
        <path d="m101.76 234.92c3.66-4 11.23-5.3 16-2.88a4.82 4.82 0 0 1 1.37 7.62c-3.79 4-11.23 5.35-16 2.89a4.88 4.88 0 0 1 -1.37-7.63z"></path>
        <path d="m374.77 307.4c3.66-4 11.23-5.3 16-2.87a4.82 4.82 0 0 1 1.37 7.62c-3.8 4.05-11.25 5.34-16 2.89a4.9 4.9 0 0 1 -1.37-7.64z"></path>
        <path d="m340.69 293.81c3.66-4 11.23-5.3 16-2.88a4.82 4.82 0 0 1 1.37 7.62c-3.79 4.05-11.24 5.34-16 2.89a4.88 4.88 0 0 1 -1.37-7.63z"></path>
        <path d="m160 258.41c-4.92 2.5-12.38 1-16-2.89a4.84 4.84 0 0 1 1.38-7.63c4.74-2.39 12.28-1.21 16 2.88a4.88 4.88 0 0 1 -1.38 7.64z"></path>
        <path d="m345.59 204.26c-2.37 5.75-9.75 10.56-15.65 10.76a4.59 4.59 0 0 1 -4.38-6.37c2.37-5.57 9.59-10.62 15.65-10.75a4.61 4.61 0 0 1 4.38 6.36z"></path>
        <path d="m310 145.55c3.66-4 11.23-5.3 16-2.87a4.82 4.82 0 0 1 1.36 7.62c-3.79 4-11.24 5.34-16 2.89a4.9 4.9 0 0 1 -1.36-7.64z"></path>
        <path d="m364.75 175.81c-4.93 2.5-12.38 1.05-16-2.89a4.85 4.85 0 0 1 1.38-7.63c4.75-2.39 12.28-1.21 16 2.88a4.88 4.88 0 0 1 -1.38 7.64z"></path>
        <path d="m457.44 225.86c-4.93 2.5-12.38 1-16-2.89a4.84 4.84 0 0 1 1.38-7.62c4.75-2.4 12.28-1.22 16 2.87a4.88 4.88 0 0 1 -1.38 7.64z"></path>
        <path d="m231.58 221.77c-4.93 2.51-12.38 1-16-2.89a4.83 4.83 0 0 1 1.38-7.62c4.75-2.4 12.28-1.22 16 2.87a4.89 4.89 0 0 1 -1.38 7.64z"></path>
        <path d="m216.79 321.39c3.67-4 11.24-5.3 16-2.88a4.82 4.82 0 0 1 1.37 7.62c-3.8 4.05-11.25 5.35-16 2.89a4.89 4.89 0 0 1 -1.37-7.63z"></path>
        <path d="m283.1 323.63c-4.93 2.51-12.38 1.05-16-2.89a4.83 4.83 0 0 1 1.38-7.62c4.74-2.39 12.28-1.22 16 2.88a4.88 4.88 0 0 1 -1.38 7.63z"></path>
        <path d="m144 293.81c3.66-4 11.23-5.3 16-2.88a4.82 4.82 0 0 1 1.37 7.62c-3.79 4.05-11.24 5.34-16 2.89a4.88 4.88 0 0 1 -1.37-7.63z"></path>
        <path d="m143.32 77c-5.24 2.47-13.25.85-17.2-3.11a4.72 4.72 0 0 1 1.36-7.63c5.2-2.37 13.15-1 17.21 3.1a4.77 4.77 0 0 1 -1.37 7.64z"></path>
        <path d="m444.64 159.86c-4.72-2.77-7.51-9.84-6.14-15.09a4.83 4.83 0 0 1 7.17-2.92c4.7 2.85 7.58 9.88 6.14 15.09a4.87 4.87 0 0 1 -7.17 2.92z"></path>
        <path d="m460.51 193c-4.93 2.5-12.38 1.05-16-2.89a4.85 4.85 0 0 1 1.38-7.63c4.75-2.39 12.29-1.21 16 2.88a4.88 4.88 0 0 1 -1.38 7.64z"></path>
        <path d="m417.06 115.07c4.08-4.16 12.14-5.46 17.21-3.11a4.71 4.71 0 0 1 1.37 7.61c-4 4-11.89 5.58-17.21 3.11a4.73 4.73 0 0 1 -1.37-7.61z"></path>
        <path d="m353.59 89.31c-5.25 2.47-13.25.85-17.21-3.11a4.72 4.72 0 0 1 1.37-7.63c5.19-2.36 13.14-1 17.21 3.1a4.78 4.78 0 0 1 -1.37 7.64z"></path>
        <path d="m213.23 114.22c-5.24 2.48-13.25.85-17.21-3.11a4.72 4.72 0 0 1 1.37-7.62c5.2-2.37 13.15-1 17.21 3.09a4.78 4.78 0 0 1 -1.37 7.64z"></path>
        <path d="m290.64 227.51c-5.25 2.48-13.26.85-17.21-3.11a4.71 4.71 0 0 1 1.36-7.62c5.2-2.37 13.15-1 17.21 3.09a4.77 4.77 0 0 1 -1.36 7.64z"></path>
        <path d="m454.59 256.34c-2.36 5.73-9.73 10.56-15.65 10.76a4.6 4.6 0 0 1 -4.39-6.37c2.37-5.57 9.6-10.62 15.65-10.75a4.62 4.62 0 0 1 4.39 6.36z"></path>
        <path d="m411.91 279.59c-5.24 2.48-13.25.85-17.21-3.11a4.72 4.72 0 0 1 1.37-7.62c5.2-2.37 13.15-1 17.21 3.09a4.77 4.77 0 0 1 -1.37 7.64z"></path>
        <path d="m189.84 52.12c-3.49 4.17-11.06 6.62-16.08 5.66a3.65 3.65 0 0 1 -2.09-6c3.41-4 10.85-6.7 16.06-5.66a3.68 3.68 0 0 1 2.11 6z"></path>
        <path d="m255.3 84.79c-3.5 4.18-11.06 6.63-16.09 5.67a3.65 3.65 0 0 1 -2.09-5.95c3.42-4 10.86-6.71 16.07-5.66a3.67 3.67 0 0 1 2.11 5.94z"></path>
      </g>
      <path
        d="m428.27 409.36c-5.19-1.93-10-2.3-13.45.15-13.42 9.47-108.07 46.15-2.22-26.82s95.4-188.42 95.4-188.42c16.57 76.14-19.81 160.96-79.73 215.09z"
        fill="#d15934"
      ></path>
      <path
        d="m130.93 424c-27.14-21.11-35.51-36.3-74-62.5-71.89-48.91-68-134.84-30.62-212.07-.65 1.67-33.88 87.77 7.13 128 41.4 40.57 53.05 58.63 43.69 60.3s35 33.17 64.49 65.29c17.25 18.82 3.59 21.75-10.69 20.98z"
        fill="#d15934"
      ></path>
    </svg>
  ),
  croissant: (props) => (
    <svg viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m55.32 8.43c-8.55-8.55-12.93-6.43-12.93-6.43-3.24-3.23-8.26-1.79-11.26-.48-1.3579647.61005348-2.9120353.61005348-4.27 0-.9491456-.4788418-2.039078-.59955091-3.07-.34-1.442516.28864869-2.8298795.80511248-4.11 1.53-1.4055087.75052111-3.0707255.84201653-4.55.25-.8473288-.33228751-1.7772648-.39171951-2.66-.17-2.48125495.22660915-4.78854268 1.37133769-6.47 3.21-1.84754848 1.67413748-3.00307497 3.97805757-3.24 6.46-.22171951.8827352-.16228751 1.8126712.17 2.66.59201653 1.4792745.50052111 3.1444913-.25 4.55-.72488752 1.2801205-1.24135131 2.667484-1.53 4.11-.25955091 1.030922-.1388418 2.1208544.34 3.07.61005348 1.3579647.61005348 2.9120353 0 4.27-1.31 3-2.75 8 .48 11.26 0 0-2.08 4.38 6.47 12.93 3.24 3.23 6.47 3.23 8.09 1.62 4-4-4-8.89.8-15.36 1.3-1.51 4-4.37 7.5-5.39.2119256.1701163.4899609.2340859.7549221.1736904.2649611-.0603956.4878093-.2385372.6050779-.4836904.3640467-1.1527265.9220486-2.2349119 1.65-3.2l4.85-4.85c.9650881-.7279514 2.0472735-1.2859533 3.2-1.65.2451532-.1172686.4232948-.3401168.4836904-.6050779.0603955-.2649612-.0035741-.5429965-.1736904-.7549221 1-3.49 3.88-6.2 5.39-7.5 6.47-4.85 11.32 3.24 15.36-.8 1.6-1.61 1.6-4.84-1.63-8.08z"
        fill="#e57e25"
      />
      <path
        d="m27.83 32.68c-.7279514.9650881-1.2859533 2.0472735-1.65 3.2-.1227899.2582582-.362196.4417848-.6434825.4932879-.2812865.0515032-.5701879-.035291-.7765175-.2332879-8.15-7.75-23.6-12.35-23.6-12.35.28864869-1.442516.80511248-2.8298795 1.53-4.11.75052111-1.4055087.84201653-3.0707255.25-4.55-.33228751-.8473288-.39171951-1.7772648-.17-2.66 0 0 5.66.81 25.06 20.21z"
        fill="#fac176"
      />
      <path
        d="m24.82 36.19c-3.49 1-6.2 3.88-7.5 5.39-.6688694.7040489-1.5577482 1.1590702-2.52 1.29-4.2403374.905283-8.63937273.7403192-12.8-.48-3.23-3.24-1.79-8.26-.48-11.26.61005348-1.3579647.61005348-2.9120353 0-4.27-.4788418-.9491456-.59955091-2.039078-.34-3.07 0 0 15.45 4.6 23.6 12.35z"
        fill="#f29c1f"
      />
      <path
        d="m5.44 33c-.33378588.0189161-.6549447-.1302211-.85585888-.3974369-.20091419-.2672159-.25500277-.6171578-.14414112-.9325631.22305425-.6464885.36415514-1.3183975.42-2 .03706075-.2645483.17842685-.5032715.39258213-.6629487s.48329527-.227033.74741787-.1870513c.54939027.0527177.95219575.5405599.9 1.09-.0740559.824845-.24868486 1.6375413-.52 2.42-.1397915.3998911-.51638257.6683124-.94.67z"
        fill="#f9eab0"
      />
      <path
        d="m4.32 39.88c-1.42 0-1.43-2.65-1.19-4.05.09388841-.5522847.61771525-.9238884 1.17-.83s.92388841.6177153.83 1.17c-.18650885.7551292-.14474611 1.5486211.12 2.28.14981769.3142221.12544686.6837441-.06434098.9755685-.18978784.2918243-.51767883.4639521-.86565902.4544315z"
        fill="#f9eab0"
      />
      <path
        d="m32.68 27.83c-2.9 2.92-1.79 1.8-4.85 4.85-19.4-19.4-25.06-20.21-25.06-20.21.23187688-2.48407955 1.38393681-4.79176616 3.23-6.47 1.67413748-1.84754848 3.97805757-3.00307497 6.46-3.24 0 0 .82 5.67 20.22 25.07z"
        fill="#f29c1f"
      />
      <path
        d="m35.88 26.18c-1.1527265.3640467-2.2349119.9220486-3.2 1.65-19.4-19.4-20.21-25.06-20.21-25.06.8827352-.22171951 1.8126712-.16228751 2.66.17 1.4792745.59201653 3.1444913.50052111 4.55-.25 1.2801205-.72488752 2.667484-1.24135131 4.11-1.53 0 0 4.6 15.46 12.35 23.6.1937246.208137.2776977.4955801.2264864.7752722-.0512112.2796921-.2315829.518734-.4864864.6447278z"
        fill="#fac176"
      />
      <path
        d="m19.49 8c-.3572656.0446582-.7112175-.10467485-.9285254-.39174682-.2173079-.28707198-.2649577-.66826983-.125-1 .1399577-.33173018.4462598-.56359498.8035254-.60825318.5816768-.14689991 1.1451586-.3582056 1.68-.63.3199237-.20677417.7295377-.21382835 1.0563914-.01819267.3268538.19563569.5141712.55997839.4830903.93963701-.031081.37965863-.2751615.70868468-.6294817.84855566-.7312138.4051196-1.5204682.69518745-2.34.86z"
        fill="#f9eab0"
      />
      <path
        d="m42.87 14.8c-.1309298.9622518-.5859511 1.8511306-1.29 2.52-1.51 1.3-4.37 4-5.39 7.5v-.06c-7.75-8.14-12.35-23.6-12.35-23.6 1.030922-.25955091 2.1208544-.1388418 3.07.34 1.3579647.61005348 2.9120353.61005348 4.27 0 3-1.31 8-2.75 11.26.48 1.2071265 4.17109513 1.3549196 8.5773932.43 12.82z"
        fill="#f29c1f"
      />
    </svg>
  ),
  toast: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m491 144.17c0 32.61-17.62 64.31-49.73 89.61v221.02c0 31.54-25.67 57.2-57.22 57.2h-256.1c-31.55 0-57.22-25.66-57.22-57.2v-221.02c-32.11-25.3-49.73-57-49.73-89.61 0-39.11 25.24-75.72 71.06-103.08 40.75-24.33 93.17-38.62 148.94-40.79 4.98-.2 9.98-.3 15-.3 61.33 0 119.55 14.59 163.94 41.09 45.82 27.36 71.06 63.97 71.06 103.08z"
          fill="#f79e60"
        ></path>
        <path
          d="m491 144.17c0 32.61-17.62 64.31-49.73 89.61v221.02c0 31.54-25.67 57.2-57.22 57.2h-256.1c-31.55 0-57.22-25.66-57.22-57.2v-30c0 31.54 25.67 57.2 57.22 57.2h226.1c31.55 0 57.22-25.66 57.22-57.2v-211.02l49.73-69.61c0-39.11-25.24-75.72-71.06-103.08-40.75-24.33-93.17-38.62-148.94-40.79 4.98-.2 9.98-.3 15-.3 61.33 0 119.55 14.59 163.94 41.09 45.82 27.36 71.06 63.97 71.06 103.08z"
          fill="#d77d41"
        ></path>
        <path
          d="m461 144.17c0 8.48-1.77 19.11-7.75 30.8-5.99 11.69-16.18 24.45-33.03 37.17-5.6 4.22-8.95 10.94-8.95 17.95v224.71c0 15-12.21 27.2-27.22 27.2h-256.1c-15.01 0-27.22-12.2-27.22-27.2v-224.71c0-7.01-3.35-13.73-8.95-17.95-33.7-25.45-40.78-51.01-40.78-67.97 0-27.72 20.57-55.9 56.44-77.32 35.67-21.29 83.66-34.33 133.56-36.52 4.99-.22 9.99-.33 15-.33 55.19 0 109.33 13.43 148.56 36.85 35.87 21.42 56.44 49.6 56.44 77.32z"
          fill="#ffe8c8"
        ></path>
        <path
          d="m461 144.17c0 8.48-1.77 19.11-7.75 30.8-5.99 11.69-16.18 24.45-33.03 37.17-5.6 4.22-8.95 10.94-8.95 17.95v224.71c0 15-12.21 27.2-27.22 27.2h-256.1c-15.01 0-27.22-12.2-27.22-27.2v-30c0 15 12.21 27.2 27.22 27.2h226.1c15.01 0 27.22-12.2 27.22-27.2v-194.71c0-7.01 3.35-13.73 8.95-17.95 16.85-12.72 27.04-25.48 33.03-37.17 5.98-11.69 7.75-22.32 7.75-30.8 0-27.72-20.57-55.9-56.44-77.32-35.67-21.29-83.66-34.33-133.56-36.52 4.99-.22 9.99-.33 15-.33 55.19 0 109.33 13.43 148.56 36.85 35.87 21.42 56.44 49.6 56.44 77.32z"
          fill="#fdd9b4"
        ></path>
        <g fill="#f2c397">
          <path d="m350.492 222.547-199.59 199.59c-2.929 2.93-2.929 7.678 0 10.607 1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196l199.59-199.59c2.929-2.93 2.929-7.678 0-10.607-2.929-2.928-7.678-2.928-10.606 0z"></path>
          <path d="m152.884 376.558c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196l141.421-141.421c2.929-2.93 2.929-7.678 0-10.607-2.929-2.928-7.678-2.928-10.606 0l-141.421 141.42c-2.929 2.93-2.929 7.678 0 10.608z"></path>
          <path d="m159.955 312.918c1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196l70.71-70.71c2.929-2.93 2.929-7.678 0-10.607-2.928-2.928-7.677-2.928-10.606 0l-70.71 70.71c-2.929 2.929-2.929 7.677 0 10.607z"></path>
          <path d="m348.51 278.733-141.422 141.421c-2.929 2.93-2.929 7.678 0 10.607 1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196l141.421-141.421c2.929-2.93 2.929-7.678 0-10.607-2.927-2.927-7.677-2.927-10.605 0z"></path>
          <path d="m341.438 342.373-70.71 70.711c-2.929 2.93-2.929 7.678 0 10.607 1.464 1.464 3.384 2.196 5.303 2.196s3.839-.732 5.303-2.196l70.71-70.711c2.929-2.93 2.929-7.678 0-10.607-2.928-2.928-7.677-2.928-10.606 0z"></path>
          <circle cx="211.354" cy="169.069" r="7.504"></circle>
          <circle cx="128.191" cy="148.076" r="7.504"></circle>
          <circle cx="157.191" cy="106.076" r="7.504"></circle>
          <circle cx="333.821" cy="120.516" r="7.504"></circle>
          <circle cx="377.9" cy="150.816" r="7.504"></circle>
        </g>
      </g>
    </svg>
  ),
  panini: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m480.967 294.73c0 17.155-6.955 32.681-18.195 43.922-11.241 11.241-26.767 18.195-43.922 18.195h-325.7c-34.309 0-62.117-27.808-62.117-62.117 0-4.275 1.731-8.129 4.523-10.931 2.802-2.793 6.656-4.524 10.931-4.524h419.026c8.541.001 15.454 6.914 15.454 15.455z"
          fill="#ffebd3"
        ></path>
        <path
          d="m233.91 356.847h-140.76c-34.309 0-62.117-27.808-62.117-62.117 0-4.275 1.731-8.129 4.523-10.931 2.802-2.793 6.656-4.524 10.931-4.524h147.746c5.069 24.069 17.052 50.238 39.677 77.572z"
          fill="#ffe0bc"
        ></path>
        <path
          d="m139.575 254.009c.846 13.519-6.986 25.337-18.457 30.4-4.967 2.193-9.132 5.838-12.368 10.198-7.067 9.523-18.398 15.701-31.178 15.701-11.962 0-22.656-5.419-29.776-13.94-4.286-5.12-10.066-8.778-16.619-10.087-17.804-3.543-31.177-19.235-31.177-38.038 0-21.42 17.36-38.79 38.791-38.79 16.918 0 69.815 15.518 69.815 15.518 15.812.54 29.981 13.247 30.969 29.038z"
          fill="#8dd470"
        ></path>
        <path
          d="m86.247 244.896 34.526-34.526c14.702-14.702 38.539-14.702 53.241 0l1.614 1.614c14.702 14.702 14.702 38.539 0 53.241l-34.526 34.526c-14.702 14.702-38.539 14.702-53.241 0l-1.614-1.614c-14.702-14.702-14.702-38.539 0-53.241z"
          fill="#d97c41"
        ></path>
        <path
          d="m235.641 296.142c-11.333 4.43-23.007 6.501-34.474 6.419l-89.585-69.834c-2.689-10.334-3.514-20.812-2.648-31.033h185.568c3.37 39.986-19.586 79.086-58.861 94.448z"
          fill="#ffaaa1"
        ></path>
        <path
          d="m201.167 302.561c-36.988-.216-71.833-22.637-86.134-59.181-5.368-13.713-7.264-27.932-6.099-41.686h91.1c-9.757 26.973-13.982 61.746 1.133 100.867z"
          fill="#fd7a6e"
        ></path>
        <path
          d="m334.87 289.539c-8.507 10.541-22.264 13.966-34.143 9.953-5.144-1.738-10.678-1.862-16.009-.833-11.644 2.249-24.172-.847-33.597-9.479-8.821-8.079-13.048-19.299-12.543-30.391.298-6.671-1.495-13.272-5.443-18.663-10.736-14.638-10-35.242 2.7-49.109 14.467-15.796 39.002-16.881 54.805-2.406 12.476 11.426 44.386 55.311 44.386 55.311 11.297 11.079 9.781 33.305-.156 45.617z"
          fill="#ace094"
        ></path>
        <path
          d="m313.1 244.896 34.526-34.526c14.702-14.702 38.539-14.702 53.241 0l1.614 1.614c14.702 14.702 14.702 38.539 0 53.241l-34.526 34.526c-14.702 14.702-38.539 14.702-53.241 0l-1.614-1.614c-14.703-14.702-14.703-38.539 0-53.241z"
          fill="#e4996d"
        ></path>
        <path
          d="m201.064 271.208c-2.431.093-5.234.01-8.345-.401-4.667-.608-10.035-1.937-15.877-4.492-9.726-4.255-16.073-9.839-20.029-14.466-3.452-4.039-1.886-10.282 3.06-12.219l27.365-10.706c1.916-.752 3.956-.68 5.729.041 1.896.763 3.482 2.277 4.286 4.338l10.705 27.365c1.936 4.946-1.577 10.334-6.894 10.54z"
          fill="#fd7a6e"
        ></path>
        <path
          d="m192.719 270.807c-4.667-.608-10.035-1.937-15.877-4.492-9.726-4.255-16.073-9.839-20.029-14.466-3.452-4.039-1.886-10.282 3.06-12.219l27.365-10.706c1.916-.752 3.956-.68 5.729.041-2.051 12.901-2.443 26.923-.248 41.842z"
          fill="#f85647"
        ></path>
        <path
          d="m372.425 254.009c-.846 13.519 6.986 25.337 18.457 30.4 4.967 2.193 9.132 5.838 12.368 10.198 7.067 9.523 18.398 15.701 31.178 15.701 11.962 0 22.656-5.419 29.776-13.94 4.286-5.12 10.066-8.778 16.619-10.087 17.804-3.543 31.177-19.235 31.177-38.038 0-21.42-17.361-38.79-38.791-38.79-16.918 0-69.815 15.518-69.815 15.518-15.812.54-29.981 13.247-30.969 29.038z"
          fill="#ace094"
        ></path>
        <path
          d="m480.967 217.272c0 4.275-1.731 8.129-4.523 10.931-2.802 2.793-6.656 4.524-10.931 4.524h-273.103l-160.965-22.574c1.628-14.311 8.119-27.138 17.783-36.802 11.241-11.241 26.767-18.195 43.922-18.195h69.762l15.516 9.808 15.506-9.808h46.549l18.123 7.706 12.91-7.706h46.549l17.536 9.808 13.487-9.808h69.762c34.309-.001 62.117 27.807 62.117 62.116z"
          fill="#ffebd3"
        ></path>
        <g fill="#ffe0bc">
          <path d="m31.033 217.272c0-17.155 6.955-32.681 18.195-43.922 11.241-11.241 26.767-18.195 43.922-18.195h69.762l15.516 9.808 15.506-9.808h31.97c-11.364 14.558-28.828 41.995-33.495 77.572h-145.922c-8.541 0-15.454-6.913-15.454-15.455z"></path>
          <path d="m256.456 201.698h-.913c-8.317 0-15.059-6.742-15.059-15.059v-31.487h31.03v31.487c.001 8.317-6.741 15.059-15.058 15.059z"></path>
          <path d="m334.032 201.698h-.913c-8.317 0-15.059-6.742-15.059-15.059v-31.487h31.03v31.487c.001 8.317-6.741 15.059-15.058 15.059z"></path>
        </g>
        <path
          d="m178.88 201.698h-.913c-8.317 0-15.059-6.742-15.059-15.059v-31.487h31.03v31.487c.001 8.317-6.741 15.059-15.058 15.059z"
          fill="#ffd4a3"
        ></path>
      </g>
    </svg>
  ),
  tortilla: (props) => (
    <svg
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="_x30_5_Burrito">
        <g>
          <g>
            <path
              d="m176 38.2c-5.8-13.3 8.6-26.8 21.4-19.9 3.5 1.9 7.8 3.2 13.4 3.2 22.6 0 22.6-20.5 45.2-20.5s22.6 20.5 45.2 20.5c5.6 0 9.9-1.3 13.4-3.2 12.8-7 27.2 6.5 21.4 19.9-11.2 25.6-34.1 55.1-80 55.1-45.8.1-68.7-29.4-80-55.1z"
              fill="#80d061"
            ></path>
          </g>
          <g>
            <path
              d="m272.4 102.3c-10.5-10.1-2.3-28.1 12.1-26.5 4 .4 8.4 0 13.6-2.2 20.9-8.6 13.1-27.6 33.9-36.2 20.9-8.6 28.7 10.3 49.6 1.7 5.2-2.2 8.6-5 11.2-8.1 9.2-11.3 27.6-4.4 27.3 10.2-.6 28-10.4 64-52.8 81.5-42.3 17.5-74.7-1-94.9-20.4z"
              fill="#95d87b"
            ></path>
          </g>
          <g>
            <path
              d="m239.6 102.3c10.5-10.1 2.3-28.1-12.1-26.5-4 .4-8.4 0-13.6-2.2-20.9-8.6-13.1-27.6-33.9-36.2-20.9-8.6-28.7 10.3-49.6 1.7-5.2-2.2-8.6-5-11.2-8.1-9.2-11.3-27.6-4.4-27.3 10.2.6 28 10.4 64 52.8 81.5 42.3 17.5 74.7-1 94.9-20.4z"
              fill="#95d87b"
            ></path>
          </g>
          <g>
            <path d="m132.9 378.7h246.2v134.2h-246.2z" fill="#fbb241"></path>
          </g>
          <g>
            <circle cx="256" cy="113" fill="#f27c7c" r="61.5"></circle>
          </g>
          <g>
            <path
              d="m225.2 113c0-41 30.8-61.5 30.8-61.5-34 0-61.5 27.6-61.5 61.5s27.6 61.5 61.5 61.5c0 0-30.8-20.5-30.8-61.5z"
              fill="#ec6161"
            ></path>
          </g>
          <g>
            <path
              d="m409.9 98.2c0-19.3-17.6-33.8-36.6-30.2-98.7 18.6-173.6 111-173.6 222.3s75 203.7 173.6 222.3c19 3.6 36.6-10.9 36.6-30.2z"
              fill="#fccc83"
            ></path>
          </g>
          <g>
            <path
              d="m199.7 290.2c0 70.9 30.5 134.2 78.1 175.6 3-3.4 6-7 8.9-10.6 36.4-46.1 56.4-104.7 56.4-165s-20-118.9-56.4-165c-2.9-3.6-5.8-7.2-8.9-10.6-47.7 41.5-78.1 104.7-78.1 175.6z"
              fill="#fcbf65"
            ></path>
          </g>
          <g>
            <path
              d="m102.1 98.2c0-19.3 17.6-33.8 36.6-30.2 98.7 18.6 173.6 111 173.6 222.3s-75 203.7-173.6 222.3c-19 3.6-36.6-10.9-36.6-30.2z"
              fill="#fcd9a4"
            ></path>
          </g>
          <g>
            <path
              d="m143.2 475.9v-371.3c0-14.6 10.4-26.3 23.6-29.1-9.1-3.2-18.5-5.7-28.1-7.5-19-3.6-36.6 10.9-36.6 30.2v384.1c0 19.3 17.6 33.8 36.6 30.2 9.6-1.8 19-4.3 28.1-7.5-13.3-2.8-23.6-14.5-23.6-29.1z"
              fill="#fccc83"
            ></path>
          </g>
          <g>
            <g>
              <circle cx="256" cy="79.6" fill="#ffe885" r="7.7"></circle>
            </g>
          </g>
          <g>
            <circle cx="199.7" cy="409.6" fill="#fccc83" r="15.5"></circle>
          </g>
          <g>
            <circle cx="175.9" cy="305.6" fill="#fccc83" r="15.5"></circle>
          </g>
          <g>
            <circle cx="348.2" cy="133.8" fill="#fcbf65" r="15.5"></circle>
          </g>
          <g>
            <circle cx="363.6" cy="434" fill="#fcbf65" r="15.5"></circle>
          </g>
          <g>
            <circle cx="234.5" cy="368.4" fill="#fccc83" r="10.3"></circle>
          </g>
          <g>
            <circle cx="373.9" cy="183.5" fill="#fcbf65" r="10.3"></circle>
          </g>
        </g>
      </g>
    </svg>
  ),
  cookies: (props) => (
    <svg viewBox="0 0 464 464" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g>
        <g>
          <path
            fill="#B97850"
            d="M455.996,225.872C443.563,230.438,429.943,232,416,232c-6.533,0-12.907-0.619-19.195-1.51 c-0.594,0.696-1.136,1.434-1.891,2.003l-13.546,10.226c-4.394,3.317-10.418,3.45-14.955,0.33L347.8,230.248 c-5.245-3.607-6.63-8.546-3.8-14.248l0,0c0.663-1.336,1.224-4.047-1.46-5.711C304.553,186.743,280,144.013,280,96 c0-27.542,8.271-53.104,22.364-74.504c2.944-4.47,0.578-10.452-4.554-11.971c-24.286-7.189-50.214-10.547-77.121-9.252 C103.176,5.925,6.965,101.163,0.376,218.628C-7.153,352.824,99.441,464,232,464c128.13,0,232-103.87,232-232 C464,229.049,462,223.667,455.996,225.872z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#A5694B"
            d="M96,232C96,120.33,174.907,27.113,280,5c-15.491-3.259-31.54-5-48-5C103.87,0,0,103.869,0,232 c0,128.13,103.87,232,232,232c16.46,0,32.509-1.741,48-5C174.907,436.886,96,343.67,96,232z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#734B46"
            d="M192.5,224.242l-7.965,23.895c-2.518,7.554,0.902,15.81,8.024,19.37l25.274,12.637 c6.16,3.08,13.599,1.873,18.469-2.997l15.012-15.012c5.191-5.191,6.184-13.25,2.406-19.546l-12.912-21.52 c-2.892-4.819-8.1-7.768-13.72-7.768h-19.409C200.792,213.301,194.678,217.708,192.5,224.242z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#734B46"
            d="M104.018,120.196l7.57,24.023c2.393,7.594,10.006,12.273,17.862,10.979l27.881-4.595 c6.795-1.12,12.111-6.463,13.198-13.263l3.349-20.964c1.158-7.25-2.767-14.358-9.519-17.24l-23.082-9.851 c-5.169-2.206-11.117-1.538-15.668,1.759l-15.717,11.387C104.314,106.472,101.948,113.628,104.018,120.196z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#734B46"
            d="M274.737,96.437l-20.25,14.978c-6.402,4.735-8.348,13.456-4.566,20.463l13.421,24.866 c3.271,6.06,10.053,9.348,16.837,8.161l20.913-3.658c7.232-1.265,12.675-7.29,13.202-14.613l1.8-25.031 c0.403-5.606-2.164-11.012-6.764-14.242l-15.884-11.154C287.811,92.249,280.274,92.342,274.737,96.437z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#734B46"
            d="M63.081,254.065l5.278,19.432c1.669,6.143,7.6,10.124,13.917,9.341l22.419-2.779 c5.464-0.677,9.882-4.775,10.967-10.173l3.346-16.64c1.157-5.754-1.751-11.558-7.052-14.076l-18.123-8.608 c-4.059-1.928-8.831-1.585-12.572,0.904l-12.919,8.594C63.757,243.112,61.638,248.752,63.081,254.065z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#734B46"
            d="M344.349,301.96l-24.542-5.665c-7.758-1.791-15.653,2.395-18.523,9.823l-10.186,26.357 c-2.483,6.424-0.576,13.716,4.733,18.102l16.367,13.522c5.66,4.676,13.776,4.9,19.686,0.544l20.2-14.892 c4.524-3.335,6.966-8.799,6.433-14.394l-1.839-19.322C356.026,309.179,351.059,303.51,344.349,301.96z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#734B46"
            d="M196.814,368.722l-13.287-15.089c-4.2-4.77-11.269-5.726-16.585-2.242l-18.866,12.362 c-4.598,3.013-6.752,8.63-5.348,13.945l4.329,16.384c1.497,5.666,6.658,9.586,12.518,9.508l20.03-0.267 c4.486-0.06,8.611-2.469,10.868-6.346l7.793-13.39C201.032,378.836,200.446,372.848,196.814,368.722z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#644141"
            d="M128.955,144.219l-7.57-24.023c-2.07-6.568,0.296-13.725,5.873-17.766l15.717-11.387 c0.333-0.242,0.719-0.365,1.066-0.579l-2.766-1.181c-5.169-2.205-11.117-1.537-15.668,1.76L109.89,102.43 c-5.577,4.041-7.943,11.197-5.873,17.766l7.57,24.023c2.393,7.594,10.006,12.273,17.862,10.979l8.046-1.326 C133.541,152.032,130.349,148.645,128.955,144.219z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#644141"
            d="M280.709,156.745l-13.421-24.866c-3.782-7.007-1.836-15.729,4.565-20.464l20.25-14.977 c0.272-0.202,0.598-0.275,0.879-0.457c-5.584-3.654-12.851-3.533-18.247,0.457l-20.25,14.977 c-6.401,4.735-8.348,13.457-4.565,20.464l13.421,24.866c3.271,6.061,10.053,9.348,16.837,8.161l7.689-1.345 C284.893,162.131,282.355,159.793,280.709,156.745z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#644141"
            d="M329.565,364.099l-16.367-13.522c-5.309-4.387-7.216-11.678-4.733-18.102l10.186-26.357 c1.437-3.717,4.132-6.621,7.438-8.373l-6.282-1.449c-7.759-1.791-15.653,2.395-18.523,9.822l-10.186,26.357 c-2.483,6.424-0.576,13.715,4.733,18.102l16.367,13.522c5.442,4.497,13.113,4.765,18.952,0.914 C330.633,364.678,330.049,364.498,329.565,364.099z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            fill="#644141"
            d="M209.926,267.506c-7.122-3.561-10.542-11.816-8.024-19.369l7.965-23.896 c2.178-6.534,8.292-10.94,15.179-10.94h-17.367c-6.887,0-13.001,4.406-15.179,10.94l-7.965,23.896 c-2.518,7.553,0.901,15.809,8.023,19.369l25.273,12.638c5.065,2.532,10.918,2.022,15.574-0.896L209.926,267.506z"
          />
        </g>
      </g>
    </svg>
  ),
  donut: (props) => (
    <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m256 0c-141.385 0-256 114.615-256 256s114.615 256 256 256 256-114.615 256-256-114.615-256-256-256zm0 326.567c-38.911 0-70.567-31.656-70.567-70.567s31.656-70.567 70.567-70.567 70.567 31.656 70.567 70.567-31.656 70.567-70.567 70.567z"
        fill="#fece85"
      />
      <path
        d="m256 0c-141.382 0-256 114.618-256 256 0 28.052 4.512 55.053 12.857 80.313 20.501 20.387 48.738 33.007 79.86 33.007 48.109 0 89.327-30.143 105.727-72.545-8.19-11.517-13.011-25.6-13.011-40.775 0-38.91 31.658-70.567 70.567-70.567 38.91 0 70.567 31.657 70.567 70.567 0 19.409-7.871 37.014-20.604 49.778v60.451c0 28.402 23.107 51.509 51.509 51.509 13.753 0 26.692-5.357 36.417-15.092 9.735-9.725 15.092-22.664 15.092-36.417v-79.324c0-5.676 4.625-10.302 10.302-10.302 3.709 0 6.15 1.896 7.283 3.018 1.123 1.133 3.018 3.575 3.018 7.283v27.815c0 28.402 23.107 51.509 51.509 51.509 2.081 0 4.152-.124 6.202-.381 15.835-33.284 24.705-70.525 24.705-109.847 0-141.382-114.618-256-256-256z"
        fill="#fece85"
      />
      <path
        d="m512 256c0 39.322-8.87 76.563-24.704 109.848-2.05.258-4.121.381-6.202.381-28.402 0-51.509-23.107-51.509-51.509v-27.815c0-3.709-1.896-6.15-3.018-7.283-1.133-1.123-3.575-3.018-7.283-3.018-5.676 0-10.302 4.626-10.302 10.302v79.324c0 13.753-5.357 26.692-15.092 36.417-9.725 9.735-22.664 15.092-36.417 15.092-28.402 0-51.509-23.107-51.509-51.509v-60.451c12.733-12.764 20.604-30.37 20.604-49.778 0-38.91-31.657-70.567-70.567-70.567s-70.567 31.657-70.567 70.567c0 15.175 4.821 29.257 13.011 40.775-16.4 42.402-57.618 72.545-105.727 72.545-31.122 0-59.359-12.62-79.86-33.007-8.346-25.261-12.858-52.262-12.858-80.314 0-141.382 114.618-256 256-256s256 114.618 256 256z"
        fill="#fec165"
      />
      <path
        d="m512 256v58.72c0 8.53-3.461 16.256-9.055 21.85-1.617 1.617-3.4 3.049-5.336 4.255-4.78 3.049-10.446 4.801-16.514 4.801-17.07 0-30.905-13.835-30.905-30.905v-27.815c0-8.53-3.461-16.256-9.055-21.85s-13.32-9.055-21.85-9.055c-17.07 0-30.905 13.835-30.905 30.905v79.324c0 8.53-3.461 16.256-9.055 21.85s-13.32 9.055-21.85 9.055c-17.07 0-30.905-13.835-30.905-30.905v-110.23c0-38.91-31.657-70.567-70.567-70.567s-70.567 31.657-70.567 70.567c0 51.21-41.506 92.716-92.716 92.716-51.214 0-92.72-41.506-92.72-92.716 0-141.382 114.618-256 256-256s256 114.618 256 256z"
        fill="#fd8087"
      />
      <path
        d="m51.509 256c0 31.39 5.645 61.461 15.988 89.245-38.951-10.982-67.497-46.781-67.497-89.245 0-141.382 114.618-256 256-256 3.255 0 6.5.062 9.735.185.979.031 1.947.072 2.915.124 1.174.051 2.349.123 3.523.196 1.071.062 2.143.134 3.204.216 2.132.165 4.255.35 6.377.556-129.287 12.919-230.245 122.036-230.245 254.723z"
        fill="#fe646f"
      />
      <path
        d="m51.509 256c0-132.687 100.958-241.804 230.245-254.723-8.468-.844-17.059-1.277-25.754-1.277-141.382 0-256 114.618-256 256s114.618 256 256 256c8.695 0 17.286-.433 25.755-1.277-129.288-12.919-230.246-122.036-230.246-254.723z"
        fill="#fec165"
      />
      <path
        d="m281.755 1.277c-2.122-.206-4.244-.391-6.377-.556-1.061-.082-2.133-.154-3.204-.216-1.174-.072-2.349-.144-3.523-.196-.968-.052-1.937-.093-2.915-.124-3.236-.123-6.481-.185-9.736-.185-141.382 0-256 114.618-256 256 0 42.464 28.546 78.263 67.497 89.245-10.343-27.784-15.988-57.855-15.988-89.245 0-132.687 100.958-241.804 230.246-254.723z"
        fill="#fe646f"
      />
      <g>
        <g>
          <path
            d="m47.56 255.141c-4.267 0-7.726-3.459-7.726-7.726v-30.905c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v30.905c0 4.267-3.459 7.726-7.726 7.726z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m454.825 215.994c-4.267 0-7.726-3.459-7.726-7.726v-30.905c0-4.267 3.459-7.726 7.726-7.726s7.726 3.459 7.726 7.726v30.905c0 4.267-3.459 7.726-7.726 7.726z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m116.218 189.979c-3.508 0-6.682-2.404-7.517-5.966l-7.046-30.092c-.972-4.155 1.607-8.312 5.762-9.285 4.158-.971 8.312 1.607 9.284 5.762l7.046 30.092c.972 4.155-1.607 8.312-5.762 9.285-.591.137-1.184.204-1.767.204z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m236.007 148.543c-3.508 0-6.682-2.404-7.517-5.966l-7.046-30.092c-.972-4.155 1.607-8.312 5.762-9.285 4.156-.97 8.311 1.607 9.284 5.762l7.046 30.092c.972 4.155-1.607 8.312-5.762 9.285-.591.138-1.184.204-1.767.204z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m365.924 127.042c-3.353 0-6.44-2.199-7.419-5.581-1.186-4.099 1.176-8.383 5.275-9.569l29.688-8.59c4.098-1.183 8.383 1.175 9.569 5.275 1.186 4.099-1.176 8.383-5.275 9.569l-29.688 8.59c-.716.207-1.44.306-2.15.306z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m97.791 301.989c-1.26 0-2.537-.309-3.719-.959-3.738-2.058-5.101-6.757-3.043-10.494l14.904-27.074c2.058-3.738 6.755-5.102 10.494-3.043 3.738 2.058 5.101 6.757 3.043 10.494l-14.904 27.074c-1.407 2.557-4.049 4.002-6.775 4.002z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m373.312 217.053c-1.26 0-2.537-.309-3.719-.959-3.738-2.058-5.101-6.757-3.043-10.494l14.904-27.074c2.059-3.738 6.758-5.101 10.494-3.043 3.738 2.058 5.101 6.757 3.043 10.494l-14.904 27.074c-1.407 2.557-4.049 4.002-6.775 4.002z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m155.584 95.568c-1.966 0-3.932-.745-5.439-2.238-3.031-3.004-3.053-7.896-.05-10.927l21.754-21.953c3.004-3.03 7.895-3.053 10.927-.05 3.031 3.004 3.053 7.896.05 10.927l-21.754 21.953c-1.51 1.525-3.499 2.288-5.488 2.288z"
            fill="#fef0ae"
          />
        </g>
        <g>
          <path
            d="m317.899 83.016c-1.64 0-3.292-.52-4.694-1.594l-24.53-18.799c-3.387-2.596-4.029-7.446-1.433-10.832 2.597-3.387 7.446-4.028 10.832-1.433l24.53 18.799c3.387 2.596 4.029 7.446 1.433 10.832-1.521 1.984-3.817 3.027-6.138 3.027z"
            fill="#fef0ae"
          />
        </g>
      </g>
    </svg>
  ),
  baguette: (props) => (
    <svg
      id="fi_3348078"
      enable-background="new 0 0 496.997 496.997"
      viewBox="0 0 496.997 496.997"
      {...props}
    >
      <g>
        <g>
          <path
            d="m475.899 41.187c64.276 64.201-367.179 501.567-434.669 434.157-47.48-47.424 11.334-183.058 131.365-302.947s255.824-178.634 303.304-131.21z"
            fill="#cf7a15"
          ></path>
          <g>
            <path
              d="m489.929 17.839c-38.448-38.403-130.223-12.688-228.463 56.848-1.781 1.26-1.431 4.004.607 4.783 33.516 12.808 67.238 28.931 62.567 40.61-5.886 14.716-66.31 1.198-107.414-9.915-.864-.234-1.777-.032-2.463.541-18.206 15.216-36.381 31.8-54.235 49.633-.01.01-.021.021-.031.031-1.419 1.418-.871 3.832 1.019 4.503 37.771 13.401 84.579 33.076 79.129 46.702-6.257 15.642-74.138-.616-114.932-11.978-1.014-.283-2.097.044-2.792.835-15.554 17.716-29.829 35.53-42.712 53.178-1.077 1.475-.422 3.566 1.296 4.185 36.99 13.342 80.404 32.125 75.144 45.276-5.624 14.061-61.04 2.345-101.819-8.42-1.169-.309-2.4.189-3.032 1.219-51.862 84.494-67.807 159.654-33.938 193.482 73.297 73.211 541.876-401.788 472.069-471.513z"
              fill="#f0a346"
            ></path>
          </g>
          <g>
            <path
              d="m489.929 17.839c-15.947-15.928-41.073-20.816-72.023-16.132 12.858 2.508 23.694 7.813 32.024 16.132 61.032 60.96-289.474 431.706-427.543 475.022 86.089 52.091 536.047-406.599 467.542-475.022z"
              fill="#eb8f21"
            ></path>
          </g>
        </g>
        <g>
          <path
            d="m65.153 346.569c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#fff4db"
          ></path>
        </g>
        <g>
          <path
            d="m51.654 385.567c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#a1550a"
          ></path>
        </g>
        <g>
          <path
            d="m104.151 351.068c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#a1550a"
          ></path>
        </g>
        <g>
          <path
            d="m128.15 255.073c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#fff4db"
          ></path>
        </g>
        <g>
          <path
            d="m168.648 246.074c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#a1550a"
          ></path>
        </g>
        <g>
          <path
            d="m179.147 279.072c9.652 0 9.668-15 0-15-9.651 0-9.667 15 0 15z"
            fill="#fff4db"
          ></path>
        </g>
        <g>
          <path
            d="m212.146 163.578c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#a1550a"
          ></path>
        </g>
        <g>
          <path
            d="m251.144 156.078c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#fff4db"
          ></path>
        </g>
        <g>
          <path
            d="m258.144 185.577c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#a1550a"
          ></path>
        </g>
        <g>
          <path
            d="m317.141 81.082c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#fff4db"
          ></path>
        </g>
        <g>
          <path
            d="m359.138 63.083c9.652 0 9.668-15 0-15-9.651 0-9.667 15 0 15z"
            fill="#a1550a"
          ></path>
        </g>
        <g>
          <path
            d="m351.639 99.081c9.652 0 9.668-15 0-15-9.652 0-9.668 15 0 15z"
            fill="#fff4db"
          ></path>
        </g>
      </g>
    </svg>
  ),
  crepe: (props) => (
    <svg viewBox="0 -7 511.99939 511" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m506.851562 76.644531c-47.117187-31.582031-75.25-40.113281-118.65625-56.4375-123.40625-37.78125-265.375-22.4375-383.046874 56.4375-5.1562505 3.453125-6.675782 10.363281-3.480469 15.679688l21.910156 36.539062c140.492187-93.664062 324.246094-93.734375 464.84375 0l21.910156-36.539062c3.191407-5.320313 1.671875-12.226563-3.480469-15.679688zm0 0"
        fill="#d3843d"
      ></path>
      <path
        d="m30.167969 92.324219c-3.191407-5.320313-1.671875-12.226563 3.484375-15.679688 72.933594-48.886719 155.207031-73.359375 236.605468-75.910156-90.535156-2.84375-183.644531 21.304687-265.109374 75.910156-5.1562505 3.453125-6.675782 10.363281-3.480469 15.679688l21.910156 36.539062c6.773437-4.515625 13.695313-8.828125 20.738281-12.953125zm0 0"
        fill="#c65c38"
      ></path>
      <path
        d="m22.714844 126.34375c-.15625.101562-.300782.21875-.449219.332031l216.550781 361.074219c7.78125 12.972656 26.585938 12.972656 34.363282 0l216.554687-361.074219c-.152344-.113281-.292969-.230469-.449219-.332031-140.898437-94.441406-325.613281-94.480469-466.570312 0zm0 0"
        fill="#ffd782"
      ></path>
      <path
        d="m266.71875 486.683594-223.753906-373.082032c-6.878906 4.0625-13.632813 8.304688-20.25 12.742188-.15625.101562-.300782.21875-.449219.332031l216.550781 361.074219c6.976563 11.628906 22.800782 12.824219 31.609375 3.605469-1.390625-1.339844-2.644531-2.894531-3.707031-4.671875zm0 0"
        fill="#fdbd40"
      ></path>
      <path
        d="m78.984375 94.632812c109.242187-50.925781 238-52.800781 350.46875-1.65625 9.050781-7.492187 15.417969-18.441406 16.1875-29.851562 2.347656-34.78125-35.503906-57.277344-64.765625-39.367188-3.316406 2.03125-7.566406 1.78125-10.5-.773437-25.066406-21.800781-62.542969-20.9375-86.605469 1.914063-1.617187 1.535156-4.089843 1.796874-5.90625.503906-14.667969-10.449219-34.300781-10.515625-49.023437-.269532-2 1.394532-4.726563 1.230469-6.503906-.441406-11.53125-10.851562-27.050782-17.503906-44.136719-17.503906-16.699219 0-31.90625 6.359375-43.355469 16.777344-2.265625 2.066406-5.613281 2.257812-8.175781.566406-6.722657-4.433594-14.773438-7.019531-23.433594-7.019531-39.722656.003906-59.707031 51.027343-24.25 77.121093zm0 0"
        fill="#c65c38"
      ></path>
      <path
        d="m113.546875 18.777344c-3.300781-.820313-6.753906-1.261719-10.308594-1.261719-39.765625 0-59.683593 51.042969-24.253906 77.117187 4.554687-2.121093 9.152344-4.160156 13.796875-6.121093-23.511719-25.574219-8.667969-62.433594 20.765625-69.734375zm0 0"
        fill="#9c2d20"
      ></path>
      <path
        d="m356.480469 186.398438c-2.910157-10.667969-12.648438-17.515626-23.664063-16.648438l-126.03125 9.894531c-.894531.070313-1.238281-1.140625-.4375-1.550781l89.636719-45.8125c6.515625-3.328125 9.054687-11.363281 5.589844-17.847656-3.402344-6.363282-11.480469-8.570313-17.90625-5.285156l-108.617188 55.511718c-22.039062 11.265625-12.554687 44.753906 12.101563 42.808594l128.085937-10.054688c.238281-.019531.328125.304688.113281.410157l-120.597656 58.800781c-21.472656 10.46875-14.238281 42.78125 9.667969 43.070312l78.480469.945313c.425781.007813.597656.554687.246094.800781l-54.421876 38.175782c-10.453124 7.332031-5.210937 23.832031 7.535157 23.832031 5.5 0 1.855469 1.589843 71.550781-47.300781 18.671875-13.097657 9.511719-41.296876-12.308594-41.5625l-72.410156-.875c-.878906-.011719-1.140625-1.195313-.355469-1.578126l121.796875-59.386718c9.9375-4.84375 14.847656-15.679688 11.945313-26.347656zm0 0"
        fill="#c65c38"
      ></path>
      <g fill="#9c2d20">
        <path d="m187.152344 207.472656 13.804687-1.085937c-22.019531-2.25-28.179687-32.378907-7.875-42.753907l104.734375-53.53125c-3.871094-2.867187-9.179687-3.492187-13.757812-1.152343l-109.007813 55.710937c-22.039062 11.265625-12.554687 44.753906 12.101563 42.8125zm0 0"></path>
        <path d="m246.753906 338.589844 39.574219-26.289063c4.847656-3.222656 2.617187-10.769531-3.203125-10.839843l-54.398438 38.160156c-10.453124 7.332031-5.210937 23.828125 7.535157 23.828125 4.660156 0 7.238281-2.183594 9.777343-3.964844-6.867187-5.570313-6.304687-15.96875.714844-20.894531zm0 0"></path>
        <path d="m212.78125 255.597656 104.519531-50.960937c3.585938-1.75 2.109375-7.164063-1.867187-6.851563l-120.679688 58.84375c-21.542968 10.503906-14.21875 42.777344 10.171875 43.074219l12.078125.144531c-18.050781-5.59375-24.917968-34.160156-4.222656-44.25zm0 0"></path>
      </g>
    </svg>
  ),
  pancake: (props) => (
    <svg id="fi_3410672" enable-background="new 0 0 512 512" viewBox="0 0 512 512" {...props}>
      <g>
        <g>
          <g>
            <path
              d="m512 348c0 103.83-85 164-201 164-103.83 0-175-78.17-175-182s106-186 188-186c103.83 0 188 100.17 188 204z"
              fill="#f9eca7"
            ></path>
            <path
              d="m326 173c-91 0-167 70.739-167 158 0 48 20.5 93.5 36 109 8.5 8.5 31 11 41 20 25.644 21.338 38 34 75 34 91.127 0 180-52 180-163 0-80-52-158-165-158z"
              fill="#dba260"
            ></path>
          </g>
          <g fill="#f9eca7">
            <path d="m451 411c0 4.971-6.268 8-14 8s-14-4.029-14-9 6.268-11 14-11 14 7.029 14 12z"></path>
            <path d="m469 284c0 3.314-3.582 6-8 6s-8-1.686-8-5 4.582-7 9-7 7 2.686 7 6z"></path>
          </g>
        </g>
        <g>
          <g>
            <path
              d="m376 196c0 103.83-91 172-188 172-103.83 0-188-76.17-188-180s106-188 188-188c103.83 0 188 92.17 188 196z"
              fill="#f9eca7"
            ></path>
            <path
              d="m192 29c-43.558 0-95.733 26.225-130 66-17.5 17.5-7 36-17 46-14 14-20 28.509-20 46 0 107 65.873 158 157 158s175-47 175-158c0-87.261-73.873-158-165-158z"
              fill="#ecb46b"
            ></path>
          </g>
          <g fill="#f9eca7">
            <path d="m253 314c0 4.971-6.268 8-14 8s-14-4.029-14-9 6.268-11 14-11 14 7.029 14 12z"></path>
            <path d="m291 272c0 3.314-3.582 6-8 6s-8-1.686-8-5 4.582-7 9-7 7 2.686 7 6z"></path>
            <path d="m82 205c0 6.627-6.716 9-15 9s-15-5.373-15-12 3.716-12 12-12 18 8.373 18 15z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  warqa: (props) => (
    <svg
      id="fi_3149105"
      enable-background="new 0 0 512 512"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m288.133 512c-19.688 0-39.637-5.865-55.637-16.23-19.05.981-39.255-3.919-56.298-13.761-17.045-9.843-31.387-24.896-40.064-41.873-16.979-8.677-32.033-23.021-41.875-40.069-9.842-17.042-14.736-37.249-13.761-56.293-10.367-16.008-16.231-35.956-16.231-55.641 0-19.687 5.864-39.633 16.231-55.635-.975-19.043 3.919-39.249 13.76-56.297 9.846-17.047 24.896-31.387 41.874-40.063 8.677-16.984 23.021-32.038 40.07-41.876 17.045-9.844 37.254-14.737 56.296-13.766 16.009-10.366 35.956-16.23 55.635-16.23s39.626 5.864 55.635 16.23c19.046-.966 39.25 3.923 56.3 13.769 17.045 9.835 31.389 24.889 40.066 41.873 16.978 8.676 32.028 23.016 41.873 40.06 9.843 17.051 14.737 37.257 13.762 56.3 10.367 16.002 16.231 35.948 16.231 55.635 0 19.684-5.864 39.632-16.231 55.641.977 19.044-3.918 39.251-13.762 56.295-9.841 17.047-24.895 31.391-41.874 40.067-8.678 16.978-23.02 32.03-40.065 41.873-17.042 9.842-37.249 14.739-56.297 13.761-16.001 10.365-35.949 16.23-55.638 16.23z"
          fill="#f0d2a0"
        ></path>
        <path
          d="m495.769 232.498c.975-19.043-3.919-39.249-13.762-56.3-9.844-17.044-24.895-31.384-41.873-40.06-8.677-16.984-23.021-32.038-40.066-41.873-17.05-9.846-37.253-14.734-56.3-13.769-16.009-10.366-35.956-16.23-55.635-16.23s-39.626 5.864-55.635 16.23c-2.855-.146-5.739-.143-8.632-.028v415.333c2.892.114 5.774.115 8.629-.032 16 10.365 35.949 16.23 55.637 16.23s39.637-5.865 55.637-16.23c19.048.979 39.255-3.919 56.297-13.761 17.045-9.843 31.387-24.896 40.065-41.873 16.979-8.677 32.033-23.021 41.874-40.067 9.843-17.044 14.738-37.251 13.762-56.295 10.369-16.008 16.233-35.957 16.233-55.64 0-19.687-5.864-39.633-16.231-55.635z"
          fill="#e6b482"
        ></path>
        <path
          d="m223.867 447.733c-19.688 0-39.637-5.865-55.637-16.23-19.05.981-39.255-3.919-56.298-13.761-17.045-9.843-31.387-24.896-40.064-41.873-16.979-8.677-32.033-23.021-41.875-40.069-9.842-17.042-14.736-37.249-13.761-56.293-10.368-16.008-16.232-35.956-16.232-55.641 0-19.687 5.864-39.633 16.231-55.635-.975-19.043 3.919-39.249 13.76-56.297 9.846-17.047 24.896-31.387 41.874-40.063 8.677-16.984 23.021-32.038 40.07-41.876 17.045-9.844 37.254-14.737 56.296-13.766 16.01-10.365 35.957-16.229 55.636-16.229s39.626 5.864 55.635 16.23c19.046-.966 39.25 3.923 56.3 13.769 17.045 9.835 31.389 24.889 40.066 41.873 16.978 8.676 32.028 23.016 41.873 40.06 9.843 17.051 14.737 37.257 13.762 56.3 10.367 16.002 16.231 35.948 16.231 55.635 0 19.684-5.864 39.632-16.231 55.641.977 19.044-3.918 39.251-13.762 56.295-9.841 17.047-24.895 31.391-41.874 40.067-8.678 16.978-23.02 32.03-40.065 41.873-17.042 9.842-37.249 14.739-56.297 13.761-16.002 10.364-35.95 16.229-55.638 16.229z"
          fill="#f8e6c3"
        ></path>
        <path
          d="m223.867 447.733v-447.733c19.679 0 39.626 5.864 55.635 16.23 19.046-.966 39.25 3.923 56.3 13.769 17.045 9.835 31.389 24.889 40.066 41.873 16.978 8.676 32.028 23.016 41.873 40.06 9.843 17.051 14.737 37.257 13.762 56.3 10.367 16.002 16.231 35.948 16.231 55.635 0 19.684-5.864 39.632-16.231 55.641.977 19.044-3.918 39.251-13.762 56.295-9.841 17.047-24.895 31.391-41.874 40.067-8.678 16.978-23.02 32.03-40.065 41.873-17.042 9.842-37.249 14.739-56.297 13.761-16.002 10.364-35.95 16.229-55.638 16.229z"
          fill="#f0d2a0"
        ></path>
        <path
          d="m167.636 166.566c-8.284 0-15.001-6.716-15.001-15 0-6.738 4.441-12.438 10.557-14.331 10.406-3.569 18.695-11.865 22.257-22.28 2.012-6.441 8.22-10.923 15.253-10.488 8.268.517 14.552 7.635 14.035 15.902v.008c-1.113 17.811-29.179 46.189-47.101 46.189z"
          fill="#fffae6"
        ></path>
        <path
          d="m280.098 281.167c8.284 0 15.001 6.716 15.001 15 0 6.738-4.441 12.438-10.557 14.331-10.406 3.569-18.695 11.865-22.257 22.28-2.012 6.441-8.22 10.923-15.253 10.488-8.268-.517-14.552-7.635-14.035-15.902v-.008c1.113-17.811 29.178-46.189 47.101-46.189z"
          fill="#f8e6c3"
        ></path>
        <path
          d="m166.566 280.098c0 8.284-6.716 15.001-15 15.001-6.738 0-12.438-4.441-14.331-10.557-3.569-10.406-11.865-18.695-22.28-22.257-6.441-2.012-10.923-8.22-10.488-15.253.517-8.268 7.635-14.552 15.902-14.035h.008c17.811 1.113 46.189 29.178 46.189 47.101z"
          fill="#fffae6"
        ></path>
        <path
          d="m281.167 167.636c0-8.284 6.716-15.001 15-15.001 6.738 0 12.438 4.441 14.331 10.557 3.569 10.406 11.865 18.695 22.28 22.257 6.441 2.012 10.923 8.22 10.488 15.253-.517 8.268-7.635 14.552-15.902 14.035h-.008c-17.811-1.113-46.189-29.179-46.189-47.101z"
          fill="#f8e6c3"
        ></path>
      </g>
    </svg>
  ),
  msemen: (props) => (
    <svg
      enable-background="new 0 0 511.995 511.995"
      viewBox="0 0 511.995 511.995"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <circle cx="255.997" cy="255.997" fill="#fff2e2" r="255.997"></circle>
        <path
          d="m511.994 255.997c0 141.382-114.614 255.996-255.996 255.996-31.393 0-61.458-5.644-89.246-15.985 21.845 6.066 44.865 9.311 68.647 9.311 141.382 0 255.996-114.614 255.996-256.007 0-109.958-69.327-203.716-166.647-239.97 107.991 30.034 187.246 129.086 187.246 246.655z"
          fill="#fee8c7"
        ></path>
        <circle cx="339.241" cy="98.764" fill="#fed2a4" r="30.715"></circle>
        <circle cx="324.07" cy="413.231" fill="#fed2a4" r="30.715"></circle>
        <circle cx="150.12" cy="357.92" fill="#fed2a4" r="17.023"></circle>
        <circle cx="424.115" cy="233.817" fill="#fed2a4" r="17.023"></circle>
        <circle cx="220.119" cy="226.093" fill="#fed2a4" r="17.023"></circle>
        <path
          d="m237.139 226.087c0 9.404-7.622 17.025-17.015 17.025-4.151 0-7.951-1.483-10.907-3.945 7.426-1.833 12.936-8.538 12.936-16.531 0-5.253-2.379-9.949-6.108-13.07 1.308-.319 2.668-.494 4.079-.494 9.393 0 17.015 7.622 17.015 17.015z"
          fill="#ffbd86"
        ></path>
        <circle cx="150.12" cy="115.109" fill="#fed2a4" r="17.023"></circle>
        <circle cx="101.572" cy="226.093" fill="#fed2a4" r="30.715"></circle>
        <path
          d="m132.289 226.087c0 16.963-13.75 30.724-30.713 30.724-7.066 0-13.585-2.39-18.776-6.427 16.119-.937 28.89-14.306 28.89-30.652 0-9.888-4.676-18.694-11.937-24.297.597-.041 1.205-.062 1.823-.062 16.963.001 30.713 13.761 30.713 30.714z"
          fill="#ffbd86"
        ></path>
        <path
          d="m354.785 413.226c0 16.963-13.75 30.724-30.713 30.724-7.066 0-13.585-2.39-18.776-6.427 16.119-.937 28.89-14.306 28.89-30.652 0-9.888-4.676-18.694-11.937-24.297.597-.041 1.205-.062 1.823-.062 16.963 0 30.713 13.761 30.713 30.714z"
          fill="#ffbd86"
        ></path>
        <path
          d="m369.956 98.759c0 16.963-13.75 30.724-30.713 30.724-7.065 0-13.585-2.39-18.776-6.427 16.119-.937 28.89-14.306 28.89-30.652 0-9.888-4.676-18.694-11.937-24.297.597-.041 1.205-.062 1.823-.062 16.963.001 30.713 13.761 30.713 30.714z"
          fill="#ffbd86"
        ></path>
        <g fill="#fed2a4">
          <circle cx="346.966" cy="226.093" r="7.725"></circle>
          <circle cx="407.091" cy="333.089" r="7.725"></circle>
          <circle cx="212.395" cy="413.231" r="7.725"></circle>
          <circle cx="203.096" cy="98.764" r="7.725"></circle>
          <circle cx="220.119" cy="358.6" r="7.725"></circle>
          <circle cx="339.241" cy="271.629" r="7.725"></circle>
          <circle cx="301.08" cy="340.814" r="7.725"></circle>
          <circle cx="237.143" cy="154.666" r="7.725"></circle>
          <circle cx="157.845" cy="287.211" r="7.725"></circle>
          <circle cx="300.802" cy="165.47" r="7.725"></circle>
          <circle cx="407.091" cy="169.138" r="7.725"></circle>
          <circle cx="262.64" cy="294.935" r="7.725"></circle>
        </g>
        <path
          d="m167.143 115.104c0 9.404-7.622 17.025-17.015 17.025-4.151 0-7.951-1.483-10.907-3.945 7.426-1.833 12.936-8.538 12.936-16.531 0-5.253-2.379-9.949-6.108-13.07 1.308-.319 2.668-.494 4.079-.494 9.394 0 17.015 7.622 17.015 17.015z"
          fill="#ffbd86"
        ></path>
        <path
          d="m441.138 233.812c0 9.404-7.622 17.025-17.015 17.025-4.151 0-7.951-1.483-10.907-3.945 7.426-1.833 12.936-8.538 12.936-16.531 0-5.253-2.379-9.949-6.108-13.07 1.308-.319 2.668-.494 4.079-.494 9.393 0 17.015 7.622 17.015 17.015z"
          fill="#ffbd86"
        ></path>
        <path
          d="m167.143 357.915c0 9.404-7.622 17.025-17.015 17.025-4.151 0-7.951-1.483-10.907-3.945 7.426-1.833 12.936-8.538 12.936-16.531 0-5.253-2.379-9.949-6.108-13.07 1.308-.319 2.668-.494 4.079-.494 9.394 0 17.015 7.622 17.015 17.015z"
          fill="#ffbd86"
        ></path>
      </g>
    </svg>
  ),
  'burger-bun': (props) => (
    <svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" {...props}>
      <g>
        <path
          d="m477.778 312.686h-443.557c-18.9 0-34.221-15.322-34.221-34.222v-.342c0-71.894 52.308-133.147 123.332-144.298 87.799-13.786 176.159-13.691 265.058.3 71.125 11.194 123.61 72.34 123.61 144.34 0 18.9-15.322 34.222-34.222 34.222z"
          fill="#fed2a4"
        ></path>
        <path
          d="m425.107 144.946c35.823 29.786 58.563 77.161 58.563 129.758 0 20.977-15.321 37.982-34.221 37.982h28.33c18.9 0 34.221-15.321 34.221-34.221 0-58.918-35.149-110.561-86.893-133.519z"
          fill="#ffbd86"
        ></path>
        <path
          d="m458.612 388.442h-404.178c-29.485 0-53.388-23.902-53.388-53.388 0-12.354 10.015-22.369 22.369-22.369h466.216c12.354 0 22.369 10.015 22.369 22.369 0 29.486-23.903 53.388-53.388 53.388z"
          fill="#ffbd86"
        ></path>
        <path
          d="m489.631 312.686h-28.853c12.354 0 22.369 10.015 22.369 22.369 0 29.485-23.902 53.388-53.388 53.388h28.853c29.485 0 53.388-23.903 53.388-53.388 0-12.354-10.015-22.369-22.369-22.369z"
          fill="#f6a96c"
        ></path>
        <g>
          <g>
            <path
              d="m95.145 180.373c-2.845 0-5.581-1.577-6.93-4.299-1.894-3.824-.33-8.459 3.494-10.353l4.818-2.386c3.825-1.896 8.46-.329 10.353 3.494 1.894 3.824.33 8.459-3.494 10.353l-4.818 2.386c-1.103.546-2.272.805-3.423.805z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m133.669 186.605c-1.54 0-3.096-.46-4.45-1.415l-4.415-3.118c-3.486-2.462-4.316-7.283-1.855-10.769 2.462-3.486 7.282-4.316 10.769-1.855l4.415 3.118c3.486 2.462 4.316 7.283 1.855 10.769-1.505 2.131-3.894 3.27-6.319 3.27z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m155.347 169.818c-1.679 0-3.369-.544-4.788-1.666l-4.014-3.176c-3.347-2.647-3.914-7.506-1.267-10.852 2.647-3.348 7.506-3.913 10.852-1.268l4.014 3.176c3.347 2.647 3.914 7.506 1.267 10.852-1.524 1.929-3.784 2.934-6.064 2.934z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m181.839 173.449c-1.335 0-2.686-.345-3.919-1.072-3.675-2.168-4.897-6.905-2.729-10.58l4.014-6.805c2.169-3.675 6.907-4.897 10.58-2.729 3.675 2.168 4.897 6.905 2.729 10.58l-4.014 6.805c-1.441 2.442-4.016 3.801-6.661 3.801z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m216.138 180.879c-1.781 0-3.57-.612-5.027-1.863l-3.965-3.402c-3.238-2.779-3.611-7.657-.832-10.894s7.657-3.613 10.894-.832l3.965 3.402c3.238 2.779 3.611 7.657.832 10.894-1.528 1.78-3.69 2.695-5.867 2.695z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m241.658 169.308c-4.268 0-7.726-3.459-7.726-7.726v-5.331c0-4.268 3.459-7.726 7.726-7.726 4.268 0 7.726 3.459 7.726 7.726v5.331c0 4.267-3.459 7.726-7.726 7.726z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m284.015 166.418c-2.768 0-5.444-1.491-6.831-4.106l-3.613-6.805c-2.001-3.769-.568-8.446 3.201-10.447 3.768-2.002 8.447-.567 10.447 3.201l3.613 6.805c2.001 3.769.568 8.446-3.201 10.447-1.155.613-2.395.905-3.616.905z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m256.482 190.234c-2.478 0-4.911-1.189-6.405-3.395-2.391-3.534-1.467-8.338 2.066-10.73l7.663-5.188c3.535-2.391 8.337-1.468 10.73 2.066 2.391 3.534 1.467 8.338-2.066 10.73l-7.663 5.188c-1.329.898-2.835 1.329-4.325 1.329z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m353.255 187.313c-2.137 0-4.263-.88-5.789-2.607l-4.014-4.536c-2.828-3.195-2.53-8.078.666-10.905 3.194-2.831 8.078-2.531 10.905.666l4.014 4.536c2.828 3.195 2.53 8.078-.666 10.905-1.469 1.302-3.296 1.941-5.116 1.941z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m313.244 177.985c-3.618 0-6.849-2.553-7.573-6.236l-1.606-8.166c-.823-4.187 1.903-8.248 6.091-9.072 4.191-.82 8.25 1.905 9.072 6.091l1.606 8.166c.823 4.187-1.903 8.248-6.091 9.072-.503.098-1.005.145-1.499.145z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m389.774 177.984c-1.619 0-3.251-.506-4.644-1.555l-6.02-4.536c-3.407-2.568-4.089-7.412-1.521-10.821 2.568-3.407 7.414-4.09 10.821-1.521l6.02 4.536c3.407 2.568 4.089 7.412 1.521 10.821-1.519 2.015-3.834 3.076-6.177 3.076z"
              fill="#fff3de"
            ></path>
          </g>
          <g>
            <path
              d="m419.892 187.373c-2.126 0-4.242-.872-5.769-2.583-2.841-3.184-2.562-8.068.623-10.908l5.218-4.655c3.184-2.84 8.069-2.561 10.908.623 2.841 3.184 2.562 8.068-.623 10.908l-5.218 4.655c-1.472 1.313-3.309 1.96-5.139 1.96z"
              fill="#fff3de"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  'cheese-slice': (props) => (
    <svg
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="m487.396 220.487c9.057 0 17.492 2.633 24.604 7.167v-67.749c0-26.035-21.108-47.154-47.154-47.154h-304.711c-26.035 0-47.143 21.119-47.143 47.154v304.711c0 26.046 21.108 47.154 47.143 47.154h15.132c-1.377-3.332-2.13-6.992-2.13-10.816 0-15.722 12.75-28.461 28.472-28.461s28.461 12.739 28.461 28.461c0 3.824-.754 7.484-2.13 10.816h236.908c26.046 0 47.154-21.108 47.154-47.154v-159.741c-7.112 4.534-15.547 7.167-24.604 7.167-25.282 0-45.778-20.496-45.778-45.778s20.494-45.777 45.776-45.777zm-122.518 232.756c-21.589 0-39.08-17.492-39.08-39.08 0-21.578 17.492-39.069 39.08-39.069 21.578 0 39.069 17.492 39.069 39.069 0 21.588-17.492 39.08-39.069 39.08z"
          fill="#ffd15b"
        ></path>
        <path
          d="m351.865.229h-230.254c1.497 3.354 2.316 7.08 2.316 10.991 0 15.044-12.204 27.248-27.248 27.248-15.055 0-27.248-12.204-27.248-27.248 0-3.911.819-7.637 2.316-10.991h-24.593c-26.046 0-47.154 21.109-47.154 47.155v304.711c0 26.035 21.108 47.143 47.154 47.143h156.343c-4.753-7.976-7.473-17.295-7.473-27.248 0-29.499 23.905-53.404 53.404-53.404s53.404 23.905 53.404 53.404c0 9.953-2.72 19.272-7.473 27.248h56.506c26.035 0 47.143-21.108 47.143-47.143v-304.711c.001-26.046-21.107-47.155-47.143-47.155zm-266.734 336.417c-11.898 0-21.534-9.647-21.534-21.534 0-11.898 9.636-21.545 21.534-21.545s21.534 9.647 21.534 21.545c0 11.887-9.636 21.534-21.534 21.534zm6.315-96.537c-32.536 0-58.921-26.385-58.921-58.921 0-32.547 26.385-58.921 58.921-58.921 32.547 0 58.932 26.374 58.932 58.921 0 32.536-26.385 58.921-58.932 58.921zm143.812-76.293c-26.483 0-47.952-21.479-47.952-47.963 0-26.483 21.469-47.952 47.952-47.952s47.963 21.469 47.963 47.952c0 26.484-21.48 47.963-47.963 47.963z"
          fill="#fee45a"
        ></path>
        <g fill="#ffd15b">
          <path d="m29.433 352.095v-304.711c0-24.375 18.486-44.423 42.205-46.903.033-.087.076-.164.109-.251h-24.593c-26.046-.001-47.154 21.108-47.154 47.154v304.711c0 26.035 21.108 47.143 47.154 47.143h29.433c-26.046 0-47.154-21.108-47.154-47.143z"></path>
          <circle cx="212.37" cy="247.738" r="27.249"></circle>
          <circle cx="329.823" cy="178.721" r="21.537"></circle>
        </g>
      </g>
    </svg>
  ),
  'pain-au-chocolat': (props) => (
    <svg
      enable-background="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          id="_x35__00000147214138330446347600000011217592041797823639_"
          d="m508.898 300.563c-4.032-28.121-12.868-73.049-40.345-115.072-35.518-54.322-103.553-95.9-179.408-101.826-103.443-8.081-168.602 27.498-216.583 71.117-88.896 80.815-72.736 152.697-69.013 180.89 6.632 50.217 60.139 92.834 114.107 85.928 18.657-2.387 192.99-7.136 257.153-13.06 61.285-5.658 144.54-35.088 134.089-107.977z"
          fill="#c4691c"
        ></path>
        <path
          id="_x34__00000183236773346073810490000006643822298500120241_"
          d="m503.874 309.681c-4.032-28.121-58.735-113.393-191.389-142.251-65.117-14.166-159.185-10.24-223.418 37.236-72.058 53.26-80.69 102.111-80.527 128.984.307 50.652 55.148 94.856 109.115 87.95 18.657-2.387 192.99-7.136 257.153-13.06 61.286-5.658 139.517-25.97 129.066-98.859z"
          fill="#f5ddbe"
        ></path>
        <path
          id="_x33__00000112595789795794564750000012454293500422211735_"
          d="m106.607 429.487c-25.338 0-51.384-9.902-71.616-27.603-21.221-18.57-33.48-43.424-33.634-68.194-.288-48.305 27.785-93.665 83.44-134.803 68.159-50.367 166.081-52.233 229.219-38.473 138.394 30.114 192.801 119.192 196.966 148.24 3.324 23.185-1.501 43.186-14.342 59.456-20.555 26.046-61.321 42.05-121.17 47.59-37.849 3.492-113.049 6.536-173.473 8.991-40.801 1.655-76.035 3.086-83.426 4.039-3.955.505-7.953.757-11.964.757zm136.171-262.089c-50.381 0-106.38 11.207-149.439 43.046-51.77 38.249-77.879 79.695-77.62 123.162.126 20.66 10.597 41.601 28.732 57.464 20.394 17.855 47.478 26.621 72.29 23.409 8.016-1.024 41.846-2.398 84.675-4.138 60.255-2.441 135.252-5.484 172.736-8.949 55.774-5.162 93.195-19.356 111.212-42.19 10.449-13.24 14.18-29.104 11.396-48.502-3.626-25.359-56.412-108.098-185.802-136.262-19.882-4.318-43.347-7.04-68.18-7.04z"
          fill="#e5914a"
        ></path>
        <path
          id="_x32__00000031886173703538335050000004457223651329969566_"
          d="m378.866 271.424c-30.566-38.112-87.894-49.123-136.665-47.675-47.01 1.396-91.693 20.946-115.057 42.734-28.683 26.749-26.737 85.038 15.243 96.918 16.019 4.535 33.015 3.803 49.61 2.467 63.779-5.135 121.906 4.721 179.136-23.893 17.686-8.844 30.72-41.892 7.733-70.551zm-111.357-141.513c3.899 0 7.059-3.16 7.059-7.059 0-3.898-3.159-7.059-7.059-7.059-3.899 0-7.059 3.161-7.059 7.059.001 3.898 3.16 7.059 7.059 7.059zm-21.821 11.292c0 3.899 3.159 7.059 7.059 7.059s7.059-3.16 7.059-7.059c0-3.898-3.159-7.059-7.059-7.059s-7.059 3.161-7.059 7.059zm-22.929-13.553c3.899 0 7.059-3.16 7.059-7.059 0-3.898-3.159-7.059-7.059-7.059s-7.059 3.16-7.059 7.059c.001 3.899 3.16 7.059 7.059 7.059zm24.421-6.209c3.899 0 7.06-3.16 7.06-7.059s-3.161-7.059-7.06-7.059c-3.897 0-7.059 3.16-7.059 7.059.001 3.899 3.162 7.059 7.059 7.059zm-35.506 28.393c3.897 0 7.059-3.16 7.059-7.059 0-3.898-3.161-7.059-7.059-7.059-3.899 0-7.06 3.161-7.06 7.059-.001 3.898 3.16 7.059 7.06 7.059zm12.803-14.149c0 3.898 3.159 7.059 7.059 7.059s7.059-3.16 7.059-7.059-3.159-7.059-7.059-7.059-7.059 3.16-7.059 7.059zm46.146 7.912c0 3.898 3.161 7.059 7.059 7.059 3.899 0 7.06-3.161 7.06-7.059s-3.161-7.059-7.06-7.059c-3.898 0-7.059 3.161-7.059 7.059z"
          fill="#29100b"
        ></path>
        <path
          id="_x31__00000067223664345797727710000006889423378633543310_"
          d="m330.172 293.567c-47.221 3.767-92.429-38.176-139.636-22.342-22.094 7.411-42.561 23.182-66.19 25.72-4.033.433-9.283.68-14.462.154-6.566 27.032 3.159 57.996 32.503 66.302 16.02 4.533 33.015 3.802 49.611 2.466 63.778-5.135 121.905 4.721 179.135-23.893 17.045-8.523 29.669-39.515 9.993-67.406-16.86 5.556-33.364 17.596-50.954 18.999z"
          fill="#6a2f1a"
        ></path>
      </g>
    </svg>
  ),
};
